module.exports = __webpack_public_path__ + "img/4.8.TSS.a3832816.png";